import React, { useState } from 'react';
import Table from '../../layout/forms/Table'
import { useEffect } from 'react';
import apiObjectHistorys from '../../../api/objectHistorys';

const ObjectHistorys = ({ selectedGlobalObjectKey }) => {
    const [objectHistorys, setObjectHistory] = useState([]);
    useEffect(() => {
        if (selectedGlobalObjectKey === null) {
            setObjectHistory([]);
            return;
        }            
        const reloadObjectHistory = async () => {
            const dataObjectHistory = await apiObjectHistorys.get(
                selectedGlobalObjectKey
            );
            setObjectHistory(dataObjectHistory);
        }
        reloadObjectHistory();
    }, [selectedGlobalObjectKey]);
    return (
        <div>           
            <Table title="Object History"
                rowsPerPage={100}
                columns={[
                    { title: 'Version', field: 'version', width: 200 },
                    { title: 'Valid From', field: 'validFrom', width: 200 },
                    { title: 'Valid To', field: 'validTo', width: 200 },     
                    { title: 'Object Name', field: 'objectName', width: 200 },     
                    { title: 'Description', field: 'description', width: 200 },     
                    { title: 'Customer Tag', field: 'customerTag', width: 200 },     
                    { title: 'Internal Tag', field: 'internalTag', width: 200 },     
                    { title: 'Global ObjectKey', field: 'globalObjectKEY', width: 200 } ,
                    { title: 'Parent ObjectKey', field: 'parentObjectKEY', width: 200 },     

                    ]} data={objectHistorys} />
        </div>
    );
};
export default ObjectHistorys;
